/**
 * Asynchronously iterates over an array and applies the callback function to each element in parallel.
 *
 * @param array - The array to iterate over.
 * @param callback - The async function to apply to each element. Should return a Promise.
 * @returns A promise that resolves when all elements have been processed.
 */
async function asyncForEach<T>(
    array: T[],
    callback: (element: T, index: number, array: T[]) => Promise<void>
): Promise<void> {
    const promises = array.map((element, index) =>
        callback(element, index, array)
    );
    await Promise.all(promises);
}

export { asyncForEach };
